<div  class="premiereDetailsDiv" fxFlex=25  >


    <div class="premiereDetails spotlightDetails" fxLayout="column">

         <div class="premiereDateTop">
             <span class="date">{{premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText   | date:'EEEE, MMM d, y, h:mm:ss a'}} {{timezone}}</span>
         </div>

         <div class="premiereHeading">
             <span class="heading">{{premiereDetails.name}}</span>
             <hr class="premiereHeadingHr"/>
         </div>

         <div class="premiereDescription">
             <p class="premiereInfo" [innerHTML] = "premiereDetails.description"></p>
             <p class="director">Directed by {{premiereDetails.directors}}</p>
            <div style="display: flex; flex-direction: column;">
                <span>Principal Cast:</span>
                <p class="cast">{{premiereDetails.cast?.join(', ') }}</p>
            </div>

             <div class="details" fxLayout="row wrap" fxLayoutGap="20%">
                 <span class="language">{{premiereDetails.language}}</span>
                 <span class="country">{{premiereDetails.country}}</span>
             </div>

             <!-- <div class="tags" fxLayout="row wrap" *ngFor="let tag of tags">
                 <span>{{tag}}</span>
             </div> -->

            <div class="tags" fxLayout="row wrap grid" *ngFor="let tag of premiereDetails.tags">
                <span>{{tag}}</span>
            </div>
        </div>

        <div fxLayout="row wrap grid" fxLayoutGap="10px">

            <button *ngIf="( !isBuyButtonActive)" (click)="open(premiereDetails.eventId, premiereDetails, 'Buy')"class="premierePageButton"
            appTrackClick
             [buttonProps]="{
               title:'spotlight_more_info_buy',
               customeId:premiereDetails.eventId,
               feature_context:'CINEJOY'
                }"
            >{{bulkPurchaseEnabled?'Buy One Tix':'Buy'}}</button>
             <button *ngIf="(bulkPurchaseEnabled&&!isBuyButtonActive)" (click)="initiateBulkPurchase(premiereDetails.eventId)" class="premierePageButton"
             appTrackClick
             [buttonProps]="{
               title:'spotlight_more_info_buy_bulk',
               customeId:premiereDetails.eventId,
               feature_context:'CINEJOY'
                }"
             >Buy Bulk Tix</button>
            <button class="premierePageButton" (click)="redirect()" [disabled]="joinButtonDisabled">Join</button>
            <button class="premierePageButton" (click)="openDialog(premiereDetails)" *ngIf="(isBuyButtonActive && createGroup)">
                <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
                <ng-container *ngIf="exsistingGroup">Manage Group</ng-container></button>
            
            <button *ngIf="!premiereDetails.bookmarked && pass" 
                 style="border: none; background-color: #DE1B36;"
                (click)="bookmarkEvent(premiereDetails.eventId, true)">
                <img src="../../../../../assets/images/LineupPass.png" alt="Bookmark Image" width="40px" height="37.5px" />
            </button>
            <button *ngIf="premiereDetails.bookmarked && pass" 
                style="border: none; background-color: #DE1B36;"
                (click)="alreadyBookmarkEvent(true)">
                <img src="../../../../../assets/images/LineupBookmarked.png" alt="Bookmark Image" width="40px" height="37.5px" />
            </button>

        </div>

        <a class="spotLightsTitle" style="font-size: 16px;color: white;margin-bottom: 5px;" [href]="groupshareUrl"
            target="_blank"
            appTrackClick
            [buttonProps]="{
              title:'spotlight_experience_with_group',
              customeId:premiereDetails.eventId,
              feature_context:'CINEJOY'
               }"
            >Experience Spotlight with Group</a>

         <div class="premiereDateBottom">
             <span class="date">{{premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText   | date:'EEEE, MMM d, y, h:mm:ss a'}} {{timezone}}</span>
         </div>

     </div>

 </div>
